import { ConnectorTypeEnum } from '@shared/enums/connector-type';

export interface MapFilters {
  search: string;
  connectorTypes: ConnectorTypeEnum[];
  availableNow: boolean;
  fastCharging: boolean;
}

export const EMPTY_MAP_FILTERS: MapFilters = {
  search: '',
  connectorTypes: [],
  availableNow: false,
  fastCharging: false,
};

export const countActiveFilters = (filters: MapFilters): number => {
  let n = 0;
  if (filters.availableNow) n++;
  if (filters.fastCharging) n++;
  n += filters.connectorTypes.length;
  return n;
};

export const hasAnyFilter = (filters: MapFilters): boolean =>
  filters.search.length > 0 ||
  filters.connectorTypes.length > 0 ||
  filters.availableNow ||
  filters.fastCharging;
